import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import { clx } from "../../../utils/Helpers";
import UICheckbox from "../UICheckbox";
import UIIcon from "../UIIcon";
import UIModal from "../UIModal";

import "./UIExportModal.scss";

const EXPORT_MODAL_ICON = (
  <UIIcon
    name="infoCircle"
    width={36}
    height={36}
    color="currentColor"
    strokeWidth={1.66667}
    decorative
  />
);

const UIExportModal = ({
  open,
  title,
  description,
  selectAllLabel,
  cancelLabel,
  confirmLabel,
  fields,
  selectedFields,
  isAllSelected,
  isIndeterminate,
  confirmDisabled,
  maxWidth,
  fieldsColumns,
  className,
  children,
  onClose,
  onCancel,
  onConfirm,
  onFieldChange,
  onSelectAll,
}) => (
  <UIModal
    open={open}
    type="info"
    title={title}
    description={description}
    icon={EXPORT_MODAL_ICON}
    cancelLabel={cancelLabel}
    confirmLabel={confirmLabel}
    onClose={onClose}
    onCancel={onCancel || onClose}
    onConfirm={onConfirm}
    confirmButtonProps={{ disabled: confirmDisabled }}
    maxWidth={maxWidth}
    PaperProps={{ className: clx("ui-export-modal", className) }}
  >
    <Box
      className="ui-export-modal__select-all"
      onClick={() => onSelectAll(!isAllSelected)}
    >
      <Typography className="ui-export-modal__select-all-label">
        {selectAllLabel}
      </Typography>
      {/* Stop propagation so clicking the checkbox itself doesn't also
          trigger the row's onClick and toggle it back. */}
      <Box onClick={(event) => event.stopPropagation()}>
        <UICheckbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          label=""
          onChange={(checked) => onSelectAll(checked)}
          className="ui-export-modal__checkbox"
        />
      </Box>
    </Box>

    <Box
      className={clx(
        "ui-export-modal__fields",
        `ui-export-modal__fields--cols-${fieldsColumns}`,
      )}
    >
      {fields.map((field) => (
        <UICheckbox
          key={field.name}
          name={field.name}
          checked={Boolean(selectedFields[field.name])}
          label={field.label}
          onChange={(checked) => onFieldChange(field.name, checked)}
          className="ui-export-modal__checkbox"
        />
      ))}
    </Box>

    {children}
  </UIModal>
);

UIExportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  selectAllLabel: PropTypes.node.isRequired,
  cancelLabel: PropTypes.node.isRequired,
  confirmLabel: PropTypes.node.isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ).isRequired,
  selectedFields: PropTypes.object.isRequired,
  isAllSelected: PropTypes.bool.isRequired,
  isIndeterminate: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", false]),
  fieldsColumns: PropTypes.oneOf([1, 2, 3, 4]),
  className: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
};

UIExportModal.defaultProps = {
  description: null,
  isIndeterminate: false,
  confirmDisabled: false,
  maxWidth: "md",
  fieldsColumns: 2,
  className: "",
  children: null,
  onCancel: undefined,
};

export default UIExportModal;
